import { createSlice, current } from '@reduxjs/toolkit'
import immutabilityUpdate from 'immutability-helper'

const widgetData = createSlice({
    name: 'widgetData',//Данные для виджетов 
    initialState: {
        list: []  //Список виджетов
        , listStandart: [] //1-Сроки; 2-Приоритет; 3-Метки
        , dataTextHtml: []//Текст HTML (Грузится каждый раз при открытии задачи)
        , dataFile: []//Файлы
        , dataParameter: []//Параметры
    },
    reducers: {
        load(state, action) {
            state.list = action.payload.list.filter(a => a.ID_Widget !== 1 & a.ID_Widget !== 2 & a.ID_Widget !== 3);
            state.listStandart = action.payload.list.filter(a => (a.ID_Widget === 1 || a.ID_Widget === 2 || a.ID_Widget === 3));
        },
        listClear(state, action) {
            state.list = [];
            state.listStandart = [];
            state.dataTextHtml = [];
            state.dataFile = [];
            state.dataParameter = [];
        },
        //Изменит сортировку
        moving(state, action) {
            const dragIndex = action.payload.dragIndex;//Первоначальный индекс элемента
            const hoverIndex = action.payload.hoverIndex;//Индекс куда перемещен элемент  

            const list = current(state.list).filter(a => /*a.ID === id_item & */a.ID_Widget !== 1 & a.ID_Widget !== 2 & a.ID_Widget !== 3)

            const list_new = immutabilityUpdate(list, {
                $splice: [
                    [dragIndex, 1],
                    [hoverIndex, 0, list[dragIndex]],
                ],
            })

            const list_new_order = list_new.map((item, index) => {
                return { ...item, Order: index + 10 };
            });

            // console.log('list', list)
            //console.log('list_new', list_new)
            // console.log('list_new_order', list_new_order)

            //Стандартные виджеты + изменения в сортировки   
            state.list = [...current(state.list).filter(a => (a.ID_Widget === 1 || a.ID_Widget === 2 || a.ID_Widget === 3)), ...list_new_order];
        },
        loadTextHtml(state, action) {
            state.dataTextHtml = action.payload.data;
        },

        loadFile(state, action) {
            state.dataFile = action.payload.data;
        },
        loadParameter(state, action) {
            state.dataParameter = action.payload.data;
        }
    }
})

export const { load, listClear, moving, loadFile, loadParameter, loadTextHtml } = widgetData.actions
export default widgetData.reducer